import { ifProd, isProd, isProductionMode } from 'Utils/env/env';

const PREFIX = '/pay';
const APP_PREFIX = isProductionMode() ? 'https://kueskiapp.page.link' : 'https://kueskios.page.link';
const KCASH_PREFIX = ifProd('https://app.kueski.com', 'https://kueski.staging.kueski.codes');
const KCASH_VENUS_PREFIX = ifProd('https://prestamo.kueski.com', 'https://prestamo.kueski.codes');
const KPAY_PREFIX = ifProd('https://prod.kueskipay.com', 'https://kueskipay-aurora.kueski.codes');
const WALLET_PREFIX = isProd() ? 'https://cuenta.kueski.com' : 'https://cuenta.kueski.codes';
export const KACCOUNT_PREFIX = ifProd('https://cuenta.kueski.com', 'https://cuenta.kueski.codes');

const repayments = {
  refunds: `${PREFIX}/perfil/reembolso-automatico`,
  savings: `${PREFIX}/perfil/saldo`,
  transactionDetail: `${PREFIX}/transacciones/:type/:subtype/:id`,
};

const ACCOUNT = `${PREFIX}/cuenta`;

const WALLET = `${WALLET_PREFIX}/billetera/agregar-tarjeta`;

const accountAdd = {
  accountAdd: `${ACCOUNT}/agregar`,
  accountAddPhone: `${ACCOUNT}/agregar/telefono`,
  accountConfirmPhone: `${ACCOUNT}/agregar/telefono/confirmar`,
  accountVerifyPhone: `${ACCOUNT}/agregar/telefono/verificar`,
};

const auth = {
  emailVerifyToken: `${PREFIX}/verificar-email`,
  resultVerification: `${PREFIX}/verificacion/identidad/resultado`,
  startVerification: `${PREFIX}/verificacion/identidad/iniciar/:id`,
};

const Urls = {
  aboutKueski: `${PREFIX}/acerca-de-kueski`,
  account: ACCOUNT,
  ...accountAdd,
  accountContact: `${PREFIX}/cuenta/contacto`,
  addNewCard2FA: WALLET,
  appHome: `${APP_PREFIX}/home`,
  appMerchants: `${APP_PREFIX}/cerca-de-ti`,
  appStore: `${APP_PREFIX}/tienda`,
  apply: `${PREFIX}/aplicar`,
  approving: `${PREFIX}/espera_2`,
  ...auth,
  authorized: `${PREFIX}/autorizado`,
  blog: 'https://kueskipay.com/',
  cancelled: `${PREFIX}/canceled`,
  cashInstallments: `${PREFIX}/comprar/prestamo-personal`,
  changePhoneNumberPhone: 'https://preguntas.frecuentes.kueski.com/hc/es/requests/new',
  channels: `${PREFIX}/canales`,
  codeChannel: `${PREFIX}/canales/codigo-de-pago`,
  completed: `${PREFIX}/completado`,
  contactInformation: `${PREFIX}/perfil/informacion-contacto`,
  contactInformationPhone: `${PREFIX}/perfil/informacion-contacto/telefono`,
  createApplicationError: `${PREFIX}/error-al-crear-aplicacion`,
  credit: `${PREFIX}/perfil/credito`,
  directDebit: `${PREFIX}/perfil/pagos/:id?/debito`,
  directDebitCards: `${PREFIX}/perfil/pagos/:id?/debito/tarjetas`,
  directDebitConfirm: `${PREFIX}/perfil/pagos/:id?/debito/confirmar`,
  directDebitSantander: `${PREFIX}/perfil/pagos/:id?/debito-santander`,
  directDebitSantanderCards: `${PREFIX}/perfil/pagos/:id?/debito-santander/tarjetas`,
  directDebitSantanderConfirm: `${PREFIX}/perfil/pagos/:id?/debito-santander/confirmar`,
  directDebitSantanderPaymentResponse: `${PREFIX}/perfil/pagos/estatus-pago`,
  domicSubscription: `${PREFIX}/pago-automatico/`,
  edit: `${PREFIX}/editar_telefono`,
  externalError: `${PREFIX}/error`,
  helpCenter: 'https://preguntas.frecuentes.kueski.com/hc/es',
  home: `${PREFIX}/inicio`,
  identityVerification: `${PREFIX}/verificacion_identidad`,
  instoreCustomer: `${PREFIX}/cliente-en-tienda`, // To deprecate
  kAccountProfile: KACCOUNT_PREFIX,
  kCash: KCASH_PREFIX,
  kCashApply: `${KCASH_PREFIX}/aplicar/recurrente`,
  kCashVenus: KCASH_VENUS_PREFIX,
  kCashVenusRegister: `${KCASH_VENUS_PREFIX}/registro`,
  kPay: KPAY_PREFIX,
  kueski: 'https://kueski.com/',
  landing: `${PREFIX}`,
  loan: `${PREFIX}/aprobado`,
  loan_detail: `${PREFIX}/perfil/prestamos/:id`,
  movements: `${PREFIX}/compras`,
  offering: `${PREFIX}/oferta`,
  overridden: `${PREFIX}/compras`,
  paymentConfirmationDetails: `${PREFIX}/perfil/prestamos/:id/comprobantes`,
  paymentMethods: `${PREFIX}/perfil/pagos/:id?`,
  policy: 'https://preguntas.frecuentes.kueski.com/hc/es/sections/12383821397915-Aviso-de-privacidad',
  profile: `${PREFIX}/compras`,
  rejected: `${PREFIX}/rechazado`,
  root: '/',
  scoring: `${PREFIX}/espera`,
  searchStore: isProductionMode() ? 'https://tienda.kueskipay.com/busqueda' : 'https://web-store.staging-pay.kueski.codes/busqueda',
  signUp: `${PREFIX}/registro`,
  statements: `${PREFIX}/estados_de_cuenta`,
  terms: 'https://preguntas.frecuentes.kueski.com/hc/es/sections/12385659058203-T%C3%A9rminos-y-condiciones',
  termsAndConditions: 'https://www.kueskipay.com/tyc',
  transfer: `${PREFIX}/conciliacion`,
  twoFactorVerificationActivity: `${PREFIX}/2fa/verificar-actividad/:id?`,
  validateIdentity: `${PREFIX}/perfil/informacion-contacto/validar-identidad`,
  validating: `${PREFIX}/validar_telefono`,
  verifyAccount: `${PREFIX}/verificar-cuenta`,
  voucherDetail: `${PREFIX}/comprar/vale`, // To deprecate
  ...repayments,
};

/* eslint-disable sort-keys-fix/sort-keys-fix */
export const PageStatus = {
  filling: Urls.apply,
  scoring: Urls.scoring,
  validating: Urls.validating,
  approving: Urls.approving,
  offering: Urls.offering,
  transfer: Urls.transfer,
  authorized: Urls.authorized,
  loan: Urls.loan,
  cancelled: Urls.cancelled,
  rejected: Urls.rejected,
  paid: Urls.profile,
  completed: Urls.completed,
};
/* eslint-enable sort-keys-fix/sort-keys-fix */

export const pusherEvent = 'status_change';
export const pusherEventRequirement = 'requirement_available';

export default Urls;
